/**
 * Singleton Nexo client.
 * Import this module everywhere that needs the nexo instance.
 * Never call nexo.create() a second time.
 */

import type { NexoClient } from '@tiendanube/nexo';
import nexo from '@tiendanube/nexo';

const instance: NexoClient = nexo.create({
  clientId: import.meta.env.VITE_CLIENT_ID as string,
  log: import.meta.env.DEV,
});

export default instance;
